import { MatPaginatorIntl } from '@angular/material/paginator';

    function getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
        return '0 de ' + length;
    }
    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' de ' + length;
}


export function GetPaginatorIntl(){ 
    const paginatorIntl = new MatPaginatorIntl();
    
    
    paginatorIntl.itemsPerPageLabel = 'Página'; 
    paginatorIntl.previousPageLabel = 'Anterior';
    paginatorIntl.nextPageLabel  = 'Siguiente';  
    paginatorIntl.firstPageLabel = "Primera Página";
    paginatorIntl.lastPageLabel = "Última Página"
    
    return paginatorIntl;
}
